module.exports = __webpack_public_path__ + "img/index-t-slide3.e816b7d6.jpg";